import type { TaxRule } from '@/features/tax-rules/types/tax-rule.types'

/** Only the latest version of a rule family can be edited; older ones are history. */
export const isSuperseded = (rule: TaxRule): boolean => rule.isLatest === false

export const latestVersionPath = (rule: TaxRule): string =>
  `/tax-rules/${rule.latestVersionId ?? rule._id}`
